module.exports = __webpack_public_path__ + "static/img/select-food.84e6040.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/select-food.png
// module id = 717
// module chunks = 37